import React, { useState } from 'react';
import { fetchData, postData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useParams, useHistory } from 'react-router-dom';

const UserForm = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const history = useHistory();

    const [formData, setFormData] = useState({
        Name: '',
        Gender: true,
        DateofBirth: '',
        // TimeoBirth: '',
        TimeoBirth: "00:00",
        PlaceofBirth: '',
        unknownTime: false,
        ContactNumber: '',
        Email: '',
    });

    // const handleChange = (e) => {
    //     const { name, value, type, checked } = e.target;
    //     setFormData((prev) => ({
    //         ...prev,
    //         [name]: type === 'checkbox' ? checked : value,
    //         ...(type === 'checkbox' && checked ? { TimeoBirth: '' } : {}), // clear TOB if checkbox is checked
    //     }));
    // };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]:
                name === "Gender"
                    ? value === "1" // convert string to boolean
                    : type === "checkbox"
                        ? checked
                        : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }
        // if (!formData.Gender) {
        //     setErrorMessage('Gender is required !');
        //     setIsLoading(false);
        //     return;
        // }
        if (!formData.DateofBirth) {
            setErrorMessage('Date of Birth is required !');
            setIsLoading(false);
            return;
        }
        if (!formData.PlaceofBirth) {
            setErrorMessage('place is required !');
            setIsLoading(false);
            return;
        }

        const CreateData = {
            ...formData,
            CreatedBy: 1,
            CompanyId: 1,
            CreatedDate: new Date(),
        };

        try {
            const response = await postData('UserApi', CreateData);
            console.log('User Profile Created successfully:', response.data);
            // history.push(`/UserPlan/${response.recordId}`); // Redirect to UserPlan with the new user's ID
            history.push(`/UserPlan/${response.recordId}`);
        } catch (error) {
            console.error('Error User Profile record:', error);
            setErrorMessage('Failed to Create User Profile. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const [isHovered, setIsHovered] = useState(false);

    const baseStyles = {
        width: "100%",
        padding: "10px",
        marginTop: "15px",
        borderRadius: "8px",
        border: "1px solid #fff",
        background: loading
            ? "#fff"
            : isHovered
                ? "#c5ec7bff" // light green on hover
                : "transparent",
        color: loading
            ? "#000"
            : isHovered
                ? "#000" // text turns black on hover
                : "#fff",
        fontWeight: "bold",
        cursor: loading ? "not-allowed" : "pointer",
        transition: "all 0.3s ease",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
    };


    return (
        <div
            className="max-w-md mx-auto p-6 rounded-xl shadow-lg mt-10"
            style={{
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                background: "#1e1e1e", // transparent white
                backdropFilter: 'blur(10px)', // optional glass effect
                WebkitBackdropFilter: 'blur(10px)', // for Safari
                marginTop: '10px',
            }}
        >
            <h2 className="text-2xl font-bold mb-4 text-center text-green-800" style={{ fontFamily: 'monospace', textTransform: 'uppercase', color: 'whitesmoke', marginTop: '-10px' }}>USER</h2>
            <form onSubmit={handleSubmit} className="space-y-4">

                {/* Name */}
                <div className='m-2'>
                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '-30px' }}>Name</label>
                    <input
                        type="text"
                        name="Name"
                        required
                        className="w-full px-4 py-2 border rounded-md"
                        value={formData.Name}
                        onChange={handleChange}
                        placeholder='Enter your name'
                        style={{
                            width: "100%",
                            padding: "10px 10px 10px 40px",
                            borderRadius: "8px",
                            border: "1px solid #4c6793",
                            background: "#2E2E2E",
                            color: "#fff",
                            outline: "none",
                            transition: "border 0.3s ease",
                        }}
                    />
                </div>

                {/* Gender */}

                <div className='m-2'>
                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Gender</label>
                    <div className="flex space-x-4 mt-1">
                        <label className="inline-flex items-center" style={{ color: 'whitesmoke', marginTop: '5px' }}>
                            <input
                                type="radio"
                                name="Gender"
                                value="1"
                                checked={formData.Gender === true}
                                onChange={handleChange}
                            />
                            <span className="ml-2">Male</span>
                        </label>
                        <label className="inline-flex items-center" style={{ color: 'whitesmoke', marginLeft: '7px', marginTop: '5px' }}>
                            <input
                                type="radio"
                                name="Gender"
                                value="0"
                                checked={formData.Gender === false}
                                onChange={handleChange}
                            />
                            <span className="ml-2">Female</span>
                        </label>
                    </div>
                </div>

                <div className='m-2'>
                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Contact Number</label>
                    <input
                        type="text"
                        name="ContactNumber"
                        required
                        className="w-full px-4 py-2 border rounded-md"
                        value={formData.ContactNumber}
                        onChange={handleChange}
                        placeholder='Enter your contact number'
                        style={{
                            width: "100%",
                            padding: "10px 10px 10px 40px",
                            borderRadius: "8px",
                            border: "1px solid #4c6793",
                            background: "#2E2E2E",
                            color: "#fff",
                            outline: "none",
                            transition: "border 0.3s ease",
                        }}
                    />
                </div>
                <div className='m-2'>
                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Email</label>
                    <input
                        type="text"
                        name="Email"
                        required
                        className="w-full px-4 py-2 border rounded-md"
                        value={formData.Email}
                        onChange={handleChange}
                        placeholder='Enter your email'
                        style={{
                            width: "100%",
                            padding: "10px 10px 10px 40px",
                            borderRadius: "8px",
                            border: "1px solid #4c6793",
                            background: "#2E2E2E",
                            color: "#fff",
                            outline: "none",
                            transition: "border 0.3s ease",
                        }}
                    />
                </div>
                {/* DOB */}
                <div className='m-2'>
                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Date of Birth</label>
                    <input
                        type="date"
                        name="DateofBirth"
                        required
                        className="w-full px-4 py-2 border rounded-md"
                        value={formData.DateofBirth}
                        onChange={handleChange}
                        style={{
                            width: "100%",
                            padding: "10px 10px 10px 40px",
                            borderRadius: "8px",
                            border: "1px solid #4c6793",
                            background: "#2E2E2E",
                            color: "#fff",
                            outline: "none",
                            transition: "border 0.3s ease",
                        }}
                    />
                </div>
                {/* Checkbox for Unknown TOB */}
                <div className="flex items-center space-x-2">
                    <input
                        type="checkbox"
                        name="unknownTime"
                        checked={formData.unknownTime}
                        onChange={handleChange}
                        style={{ marginTop: '10px' }}
                    />
                    <label className="text-sm text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px', marginLeft: '5px' }}> I don’t know my time of birth</label>
                </div>

                {/* TOB */}
                {!formData.unknownTime && (
                    <div className='m-2'>
                        <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Time of Birth</label>
                        <input
                            type="time"
                            name="TimeoBirth"
                            className="w-full px-4 py-2 border rounded-md"
                            //value={formData.TimeoBirth}
                            value={formData.TimeoBirth || "00:00"}  // fallback to 00:00
                            onChange={handleChange}
                            required
                            style={{
                                width: "100%",
                                padding: "10px 10px 10px 40px",
                                borderRadius: "8px",
                                border: "1px solid #4c6793",
                                background: "#2E2E2E",
                                color: "#fff",
                                outline: "none",
                                transition: "border 0.3s ease",
                            }}
                        />
                    </div>
                )}
                {/* Place of Birth */}
                <div className='m-2'>
                    <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase', marginTop: '10px' }}>Place of Birth</label>
                    <input
                        type="text"
                        name="PlaceofBirth"
                        required
                        className="w-full px-4 py-2 border rounded-md"
                        value={formData.PlaceofBirth}
                        onChange={handleChange}
                        placeholder='Enter your place of birth'
                        style={{
                            width: "100%",
                            padding: "10px 10px 10px 40px",
                            borderRadius: "8px",
                            border: "1px solid #4c6793",
                            background: "#2E2E2E",
                            color: "#fff",
                            outline: "none",
                            transition: "border 0.3s ease",
                        }}
                    />
                </div>
                {/* Submit Button */}

                <div className='m-4'>
                    <button
                        type="submit"
                        disabled={loading}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        style={baseStyles}
                    >
                        Save User Details
                    </button>
                </div>
            </form>
        </div>
    );
};

export default UserForm;
